import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { ErrorBoundary, initSentry } from './lib/sentry';
import '@fontsource/inter/300.css';
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import './styles/ds.css';
import './styles/admin.css';

initSentry();

createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary fallback={<p style={{ padding: 24 }}>Something went wrong. Reload the page.</p>}>
      <App />
    </ErrorBoundary>
  </React.StrictMode>,
);
